import { Link, NavLink } from 'react-router-dom'
import { FaBars, FaXmark } from 'react-icons/fa6'
import { logo } from '../../assets/images'
import { company, navLinks } from '../../data/siteData'

function Navbar({ isMenuOpen, onToggleMenu, onCloseMenu }) {
  return (
    <div className={`corp-navbar-shell${isMenuOpen ? ' is-menu-open' : ''}`}>
      <div className="container corp-container">
        <nav className="navbar navbar-expand-xl navbar-light corp-navbar" aria-label="Primary navigation">
          <div className="corp-navbar-top">
            <Link
              className="navbar-brand corp-brand corp-brand--header"
              to="/"
              aria-label={`${company.name} home`}
              onClick={onCloseMenu}
            >
              <div className="footer-brand__mark">
                <img src={logo} alt="" aria-hidden="true" />
                <div className="footer-brand__wordmark">
                  <span className="footer-brand__primary">{company.brandPrimary}</span>
                  <span className="footer-brand__secondary">{company.brandSecondary}</span>
                </div>
              </div>
            </Link>

            <button
              className={`navbar-toggler corp-navbar-toggler${isMenuOpen ? ' is-open' : ' collapsed'}`}
              type="button"
              aria-controls="mainNavbar"
              aria-expanded={isMenuOpen}
              aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
              onClick={onToggleMenu}
            >
              {isMenuOpen ? (
                <FaXmark className="corp-navbar-toggler__icon" aria-hidden="true" />
              ) : (
                <FaBars className="corp-navbar-toggler__icon" aria-hidden="true" />
              )}
            </button>
          </div>

          <div className="collapse navbar-collapse corp-navbar-collapse" id="mainNavbar">
            <ul className="navbar-nav ms-auto align-items-xl-center">
              {navLinks.map((link) => (
                <li className="nav-item" key={link.path}>
                  <NavLink
                    className={({ isActive }) => `nav-link corp-nav-link ${isActive ? 'active' : ''}`}
                    to={link.path}
                    onClick={onCloseMenu}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
              <li className="nav-item corp-nav-cta-item">
                <Link className="corp-quote-btn" to="/contact#quote-form" onClick={onCloseMenu}>
                  Get A Quote
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Navbar
